import axios from "axios"
import setupInterceptors from "@/services/setup-api-interceptors"

const authApi = axios.create({
  baseURL: process.env.VITE_API_AUTHENTICATION_URL,
  headers: {
    "Content-Type": "application/json"
  }
})

setupInterceptors(authApi)

export default authApi
